export default __webpack_public_path__ + "static/media/mail-failed-colored.21e2c7f3.svg";